import { JsonToken } from './json-token.interface';
import { JsonTokenKind } from './json-token-kind.enum';

const JSON_TOKEN_PATTERN =
	/("(?:\\.|[^"\\])*")(?=\s*:)|("(?:\\.|[^"\\])*")|\b(true|false|null)\b|(-?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?)|([{}[\],:])/g;

const JsonTokenClasses: Record<JsonTokenKind, string> = {
	[JsonTokenKind.KEY]: 'text-(--color-syntax-key)',
	[JsonTokenKind.STRING]: 'text-(--color-syntax-string)',
	[JsonTokenKind.NUMBER]: 'text-(--color-syntax-number)',
	[JsonTokenKind.KEYWORD]: 'text-(--color-syntax-keyword)',
	[JsonTokenKind.PUNCTUATION]: 'text-(--color-syntax-punctuation)',
	[JsonTokenKind.PLAIN]: '',
};

const toToken = (text: string, kind: JsonTokenKind): JsonToken => ({
	text,
	kind,
	styleClass: JsonTokenClasses[kind],
});

const matchKind = (match: RegExpMatchArray): JsonTokenKind => {
	if (match[1] !== undefined) return JsonTokenKind.KEY;
	if (match[2] !== undefined) return JsonTokenKind.STRING;
	if (match[3] !== undefined) return JsonTokenKind.KEYWORD;
	if (match[4] !== undefined) return JsonTokenKind.NUMBER;
	return JsonTokenKind.PUNCTUATION;
};

export const tokenizeJson = (json: string): JsonToken[] => {
	const tokens: JsonToken[] = [];
	let position = 0;
	for (const match of json.matchAll(JSON_TOKEN_PATTERN)) {
		const index = match.index ?? 0;
		if (index > position) {
			tokens.push(toToken(json.slice(position, index), JsonTokenKind.PLAIN));
		}
		tokens.push(toToken(match[0], matchKind(match)));
		position = index + match[0].length;
	}
	if (position < json.length) {
		tokens.push(toToken(json.slice(position), JsonTokenKind.PLAIN));
	}
	return tokens;
};
